import { unitMapping } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = {
  size?: keyof typeof unitMapping;
  color?: Color;
};

export const LineupLocked = ({ size = 1, color = 'currentColor' }: Props) => {
  return (
    <svg
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: unitMapping[size] }}
    >
      <path
        d="M16.499 5.38275V18.7499L16.1133 19.1357H8.01562L7.62988 18.7499V5.38275L8.01562 4.99701H16.1133L16.499 5.38275ZM6.21582 6.41107V17.8505L5.83008 18.2363H3.77441L3.38867 17.8505V6.41107L3.77441 6.02533H5.83008L6.21582 6.41107ZM20.6133 6.41107V17.8505L20.2275 18.2363H18.1699L17.7852 17.8505V6.41107L18.1699 6.02533H20.2275L20.6133 6.41107ZM2.10254 7.3847V16.8759L1.7168 17.2617H0.537109L0.151367 16.8759V7.3847L0.537109 6.99896H1.7168L2.10254 7.3847ZM23.8477 7.3847V16.8759L23.4619 17.2617H22.2822L21.8965 16.8759V7.3847L22.2822 6.99896H23.4619L23.8477 7.3847ZM12 8.40814C10.9901 8.40819 10.171 9.22732 10.1709 10.2372V11.1523H9.25684V15.7245H14.7432V11.1523H13.8291V10.2372C13.829 9.22729 13.01 8.40814 12 8.40814ZM12.457 14.3525H11.543V12.5234H12.457V14.3525ZM12 9.32318C12.505 9.32318 12.9149 9.73233 12.915 10.2372V11.1523H11.0859V10.2372C11.0861 9.73236 11.4951 9.32323 12 9.32318Z"
        fill={color}
      />
    </svg>
  );
};
